// Hard-coded room block contracts for The Masters 2027.
//
// Transcribed from the signed agreements held in the events folder. These are
// fixed commitments for a single event, so they live in code rather than in the
// database - there is nothing here for anyone to maintain between now and April
// 2027. Keyed on the `hotels` collection document ID rather than the hotel name,
// because the display names in the database do not match the names on the
// contracts (and there are two near-duplicate Holiday Inn records).

// The eight sellable nights covered by the Hilton blocks. A night is identified
// by the date it is slept on, so "2027-04-05" is the night of Monday 5 April.
export const CONTRACT_NIGHTS = ["2027-04-05", "2027-04-06", "2027-04-07", "2027-04-08", "2027-04-09", "2027-04-10", "2027-04-11", "2027-04-12"]

export const HOTEL_CONTRACTS = {
	// 2027 Golf Holidays 4.2027_HGI.pdf
	rMSWIsbhzvBIKobjzlj1: {
		label: "Hilton Garden Inn",
		contract_name: "Hilton Garden Inn Columbia Downtown",
		// 1 King Bed plus 2 Queen Beds, per night. Sums to the 271 below.
		nightly_block: {
			"2027-04-05": 4,
			"2027-04-06": 10,
			"2027-04-07": 10,
			"2027-04-08": 33,
			"2027-04-09": 68,
			"2027-04-10": 68,
			"2027-04-11": 68,
			"2027-04-12": 10,
		},
		room_nights: 271,
		// Peak rooms held per night, by type, as listed on the agreement.
		room_types: [
			{ label: "1 King Bed", peak_rooms: 40 },
			{ label: "2 Queen Beds", peak_rooms: 28 },
		],
		rate: "$201 per night",
		cut_off: "2027-02-11",
		attrition: "85% of anticipated room revenue",
		deposit: "$15,581.52",
	},

	// 2027 Golf Holidays 4.2027_Home2.pdf
	"9zdRtUXHte8aancjJTOM": {
		label: "Home2 Suites",
		contract_name: "Home2 Suites Columbia Downtown",
		// 1 King Studio, 2 Queen Studio and 1 King Suite, per night. Sums to 322.
		nightly_block: {
			"2027-04-05": 11,
			"2027-04-06": 26,
			"2027-04-07": 41,
			"2027-04-08": 56,
			"2027-04-09": 56,
			"2027-04-10": 56,
			"2027-04-11": 56,
			"2027-04-12": 20,
		},
		room_nights: 322,
		// Peak rooms held per night, by type, as listed on the agreement.
		room_types: [
			{ label: "2 Queen Studio", peak_rooms: 30 },
			{ label: "1 King Studio", peak_rooms: 25 },
			{ label: "1 King Suite", peak_rooms: 1 },
		],
		rate: "$201 studios, $299 suite",
		cut_off: "2027-02-11",
		attrition: "85% of anticipated room revenue",
		deposit: "$16,352.00",
	},

	// GOLFHOLIDAYSDIRECT.COM Room Block Agreement 4.7.27-4.10.27 - signed.pdf
	PGiQ305nbisKJEJm1K1j: {
		label: "Holiday Inn",
		contract_name: "Holiday Inn Columbia Downtown",
		// 4 Kings plus 12 Queen/Queen held across three nights, 7-10 April.
		nightly_block: {
			"2027-04-07": 16,
			"2027-04-08": 16,
			"2027-04-09": 16,
		},
		// The block is 16 rooms across 3 nights (48), but the contract states
		// "Approx. 45 room nights" and prices the commitment at $9,405 (45 x $209).
		// The stated figure is what we are held to, so that is what we track.
		room_nights: 45,
		room_nights_note: "Contract states approx. 45, block totals 48",
		// Rooms held per night, by type, as listed on the agreement.
		room_types: [
			{ label: "Queen/Queen", peak_rooms: 12 },
			{ label: "Kings", peak_rooms: 4 },
		],
		rate: "$209 per night",
		cut_off: "",
		attrition: "80% - minimum 36 rooms",
		deposit: "$3,000.00 due 2026-09-04",
	},
}

// Total room nights we are contracted to fill across all three properties.
export const TOTAL_CONTRACTED_ROOM_NIGHTS = Object.values(HOTEL_CONTRACTS).reduce((total, contract) => total + contract.room_nights, 0)
